import {
  createPlugin,
  createRoutableExtension,
} from '@backstage/core-plugin-api';

import { rootRouteRef } from './routes';
import { Entity } from '@backstage/catalog-model';

export const KUBERNETES_ID_ANNOTATION = 'backstage.io/kubernetes-id';

export interface K8sExecTarget {
  kubernetesId: string;
}

export const parseK8sExecTarget = (entity: Entity): K8sExecTarget | undefined => {
  const kubernetesId = entity.metadata.annotations?.[KUBERNETES_ID_ANNOTATION];
  if (!kubernetesId) return undefined;
  return { kubernetesId };
};

export const isK8sExecEnabled = (entity: Entity): boolean => {
  return Boolean(parseK8sExecTarget(entity));
};

export const k8SExecPlugin = createPlugin({
  id: 'k8s-exec',
  routes: {
    root: rootRouteRef,
  },
});

export const K8SExecPage = k8SExecPlugin.provide(
  createRoutableExtension({
    name: 'K8SExecPage',
    component: () =>
      import('./components/ShellManager').then(m => m.ShellManager),
    mountPoint: rootRouteRef,
  }),
);
